import { render } from "./Sale_Profile.vue?vue&type=template&id=3525d87a&scoped=true"
import script from "./Sale_Profile.vue?vue&type=script&lang=js"
export * from "./Sale_Profile.vue?vue&type=script&lang=js"

import "./Sale_Profile.vue?vue&type=style&index=0&id=3525d87a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3525d87a"]])

export default __exports__